/**
 * Public site origin helper.
 *
 * Every absolute URL the app emits (canonical links, robots.txt Sitemap directive,
 * sitemap.xml entries, og:url, JSON-LD) MUST be built through this module so the
 * origin is controlled by a single env var and never hardcoded.
 */

const raw = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined;

/**
 * The public origin of the site, without a trailing slash.
 *
 * Fallback is the STAGING host — if the variable is ever missing we must fail safe
 * toward staging, never toward production.
 */
const FALLBACK_ORIGIN = "https://staging.devhubai.net";

export const SITE_URL: string = (raw?.trim() || FALLBACK_ORIGIN).replace(/\/+$/, "");

/**
 * Join `SITE_URL` with a path, guaranteeing exactly one `/` between them and
 * preserving any query string or hash the caller passes.
 *
 * @example
 * absoluteUrl("/login")  // "https://staging.devhubai.net/login"
 * absoluteUrl("")        // "https://staging.devhubai.net/"
 * absoluteUrl("/")       // "https://staging.devhubai.net/"
 */
export function absoluteUrl(path: string): string {
  // Normalise: strip leading slashes so we can join with exactly one.
  const stripped = path.replace(/^\/+/, "");
  return `${SITE_URL}/${stripped}`;
}
